import { render } from "./ServicesPage.vue?vue&type=template&id=70a45b1a"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__